import * as React from 'react'

import { appMounted } from './model'

export const useSession = () => {
  React.useEffect(() => {
    appMounted()
  }, [])
}
